// Single source of regex patterns (ARCHITECTURE-DECISIONS golden rule).
export const REGEX = Object.freeze({
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  STRONG_PASSWORD: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9!@#$%^&*])[^\s]{8,}$/,
  // Individual password-strength checks for the live signup checklist.
  HAS_LOWERCASE: /[a-z]/,
  HAS_UPPERCASE: /[A-Z]/,
  HAS_NUMBER_OR_SYMBOL: /[0-9!@#$%^&*]/,
  // The editable half of a Contract/Shipment ID; the prefix box is read-only on both.
  REFERENCE_ID_NUMBER: /^[A-Za-z0-9]{1,10}$/,
  // Only the shipment prefix is ever typed, e.g. "OI" in "OI – 238478".
  SHIPMENT_ID_PREFIX: /^[A-Za-z0-9]{1,4}$/,
  // A positive number, optionally with decimals — quantities, density, emissions.
  POSITIVE_DECIMAL: /^\d+(\.\d+)?$/,
  // A number, optionally negative/decimal — the GHG breakdown fields, which can subtract out.
  SIGNED_DECIMAL: /^-?\d+(\.\d+)?$/,
  // Matches `${token}` placeholders in i18n label templates (see lib/utils/i18n.js).
  I18N_INTERPOLATION: /\$\{(\w+)\}/g,
  // A rendered DATE_FORMAT value, so a client-side sort can order dd/MM/yyyy chronologically.
  DISPLAY_DATE: /^(\d{2})\/(\d{2})\/(\d{4})$/,
  // An activity log's iscc-frontend site link, `/sites/12` — the capture is the site's db id.
  LEGACY_SITE_PATH: /^\/sites\/(\d+)$/,
  // A `^5^` footnote reference inside a PoS label; split() keeps the capture as the superscript.
  SUPERSCRIPT_MARKER: /\^([^^]+)\^/,
});
